var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57129 3C5.12357 3 5.57129 3.44772 5.57129 4V17C5.57129 18.1046 6.46672 19 7.57129 19H20.5713C21.1236 19 21.5713 19.4477 21.5713 20C21.5713 20.5523 21.1236 21 20.5713 21H7.57129C5.36215 21 3.57129 19.2091 3.57129 17V4C3.57129 3.44772 4.019 3 4.57129 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2784 3.29289C18.8879 2.90237 18.2547 2.90237 17.8642 3.29289L15.8642 5.29289C15.4737 5.68342 15.4737 6.31658 15.8642 6.70711C16.2547 7.09763 16.8879 7.09763 17.2784 6.70711L17.5713 6.41421V9C17.5713 12.3137 14.885 15 11.5713 15H8.57129C8.019 15 7.57129 15.4477 7.57129 16C7.57129 16.5523 8.019 17 8.57129 17H11.5713C15.9896 17 19.5713 13.4183 19.5713 9V6.41421L19.8642 6.70711C20.2547 7.09763 20.8879 7.09763 21.2784 6.70711C21.6689 6.31658 21.6689 5.68342 21.2784 5.29289L19.2784 3.29289Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUp);
export default __webpack_public_path__ + "static/media/line-up.c31648c0e4694460dfcd7c314054843f.svg";
export { ForwardRef as ReactComponent };